import apiWorker from '../apiWorker'

const microsoft = {
    sync              : ()      => apiWorker('post',  `/api/v1/core/microsoft/subscriptions/sync`),
    info              : ()      => apiWorker('get',  `/api/v1/core/microsoft/subscriptions/info`),
    getAttachments    : (data)  => apiWorker('post',  `/api/v1/core/microsoft/emails/getAttachments`, data, true),
}

export default microsoft;